export default __webpack_public_path__ + "images/kvd-certified-hero-banner.svg";